import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import AboutHorses from '../../HorsesCard/AboutHorses/AboutHorses';
import styles from './RaceStats.module.scss';
const RaceStats = ({ horse }) => {
    var _a;
    const { t } = useTranslation();
    const raceData = horse
        ? {
            [t('daily_race')]: ((_a = horse.volatile.dailyRaces) !== null && _a !== void 0 ? _a : 0) + '/5',
            [t('class')]: horse.volatile.class,
            [t('race_points')]: horse.volatile.rp,
            [t('prize_money')]: horse.volatile.earnings,
            [t('all-time-ppr')]: horse.volatile.rpAllTimeHigh,
            [t('season_ppr')]: horse.volatile.rpSeasonHigh,
            [t('career')]: horse.volatile.career
        }
        : {
            [t('daily_race')]: '0/5',
            [t('class')]: 5,
            [t('race_points')]: 0,
            [t('prize_money')]: '0',
            [t('all-time-ppr')]: '0',
            [t('season_ppr')]: '0',
            [t('career')]: '0-0-0-0'
        };
    return _jsx(AboutHorses, { borderRight: true, className: styles.element, elem: raceData });
};
export default RaceStats;
